import { Box, Stack, Text, Title, Alert } from "@mantine/core";
import { useOutletContext } from "react-router-dom";
import type { PrivateContext } from "@/components/layout/PrivateLayout";
import { edits } from "@/content/edits";
import { hasScope } from "@/lib/auth";
import { AudioPlayer } from "@/components/audio/AudioPlayer";
import { EmptyState } from "@/components/common/EmptyState";

export default function PrivateEdits() {
  const { session } = useOutletContext<PrivateContext>();

  if (!hasScope(session, "edits-mashups")) {
    return (
      <EmptyState
        title="Out of scope"
        body="Your token doesn't include `edits-mashups`."
      />
    );
  }

  return (
    <Stack gap="lg">
      <Box>
        <Title order={1}>Edits / mashups / DJ tools</Title>
        <Alert color="yellow" mt="sm" variant="light">
          DJ-set material — not for redistribution. Often uses unlicensed source material.
        </Alert>
      </Box>

      {edits.length === 0 ? (
        <EmptyState title="No edits available yet" />
      ) : (
        <Stack gap="md">
          {edits.map((edit) => (
            <Box
              key={edit.slug}
              p="md"
              style={{
                background: "var(--color-deep)",
                border: "1px solid var(--color-ocean)",
                borderRadius: 12,
              }}
            >
              <Text fw={600}>{edit.title}</Text>
              <Text size="xs" c="dimmed" mb="xs">
                Sources:{" "}
                {edit.sourceCredits
                  .map((s) => `${s.artist} — ${s.title}`)
                  .join(" · ")}
              </Text>
              <AudioPlayer audio={edit.audio} session={session} />
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
